import React from 'react';

import { MenuItem } from '@mui/material';

import { useBaseWidget } from 'hooks/useBaseWidget';

import { useConfigurationStore } from 'store/configurationsStore';

import { ExportDropdown } from 'components/common/ExportDropdown/exportDropdown';
import { TooltipIcon } from 'components/common/TooltipIcon/tooltipIcon';
import { WidgetTitle } from 'components/common/WidgetTitle/WidgetTitle';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import { BarChart } from 'components/common/charts/barChart/barChart';
import { Pills } from 'components/common/pills/pills';

import { correlationTooltip } from 'components/DesignSystem/Tabs/tabs.consts';
import { useActivityLevelDriversLogic } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.logic';
import classes from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.module.scss';
import { useActivityLevelDriversProvider } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.provider';
import { ExportToCsvButton } from 'components/widgets/RiskRegister/components/ExportToCsvButton/ExportToCsvButton';

export const ActivityLevelDrivers = ({
    widgetId,
    projectId,
    contractId,
    latestVersionId,
    setSubTitleForExport,
    activeTab,
}) => {
    const { routeId: id, endpoints, name: title } = useConfigurationStore().activityLevelDrivers;

    const { api, ui } = useActivityLevelDriversProvider({ latestVersionId, endpoint: endpoints.activityLevelDrivers });

    const { logic } = useActivityLevelDriversLogic({ api, ui });

    const { subTitle } = useBaseWidget({
        id,
        widgetId,
        projectId,
        contractId,
        latestVersionId,
        title,
        setSubTitleForExport,
    });

    return activeTab === 'chart' ? (
        <WidgetWithTitle
            id={id}
            title={<WidgetTitle title={title} />}
            titleComponents={[
                <TooltipIcon
                    key={'info'}
                    tooltip={{
                        link: null,
                        infoList: correlationTooltip,
                    }}
                />,
                <ExportDropdown key={'export'} title={title} subTitle={subTitle}>
                    <MenuItem>
                        <ExportToCsvButton
                            headers={logic.exportCsv.headers}
                            rows={logic.exportCsv.rows}
                            fileName={logic.exportCsv.fileName}
                        />
                    </MenuItem>
                </ExportDropdown>,
            ]}
            titleFilters={
                <div className={classes.pills}>
                    <Pills>
                        Target Activity: <span className={classes.value}>{logic.taskVersionLabel}</span>
                    </Pills>
                    <Pills>
                        Number of iterations: <span className={classes.value}>{logic.numOfIterations}</span>
                    </Pills>
                </div>
            }
        >
            <div className={classes.chart}>
                <div className={classes.chartScroll}>
                    <BarChart
                        options={logic.options}
                        series={logic.series}
                        height={logic.chartHeight}
                        noData={false}
                        isFetching={false}
                    />
                </div>
            </div>
        </WidgetWithTitle>
    ) : null;
};
